import { render, staticRenderFns } from "./NotificationFilterEditor.vue?vue&type=template&id=ef803cf0&scoped=true"
import script from "./NotificationFilterEditor.vue?vue&type=script&lang=js"
export * from "./NotificationFilterEditor.vue?vue&type=script&lang=js"
import style0 from "./NotificationFilterEditor.vue?vue&type=style&index=0&id=ef803cf0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef803cf0",
  null
  
)

export default component.exports